import DropdownSystemV2 from './DropdownSystemV2';
import './DropdownSystemV2.scss';

export default DropdownSystemV2;
